import NormalGameManager from "../../manager/NormalGameManager";
import normalMode from "../../normalMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Plot extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;

    private mParentScript : normalMode ;

    closeFun :()=>void = null;

    start(){
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    bindData( gameLayer : normalMode ){
        this.mParentScript = gameLayer;
        this.mParentScript.btnSkipNode.active = false;
    }

    onBtnClose(){
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            // this.mParentScript.btnSkipNode.active = true;
            this.closeFun && this.closeFun();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

    protected update(dt: number): void {
        NormalGameManager._instance.pauseTimer();
    }

    protected onDisable(): void {
        NormalGameManager._instance.resumeTimer();
    }

}
